import { IState } from '../store';
import { IRecommendedVillages } from '../types/recommendedVillages';

export const selectRecommendedVillages = ({ recommendedVillages }: IState): IRecommendedVillages | null => {
  return recommendedVillages
    ? {
        ...recommendedVillages,
        villageList: recommendedVillages.villageList.slice(0, 4),
      }
    : null;
};
